import React, { Component, useState, useCallback, useEffect, useRef } from "react";
import { LogViewer } from '@patternfly/react-log-viewer';
import dayjs from 'dayjs';
// import { FixedSizeList } from "react-window";
// import InfiniteLoader from "react-window-infinite-loader";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { Dialog as PrimeDialog } from 'primereact/dialog';
import { styled, useTheme } from '@mui/material/styles';
/*
import Paper from '@mui/material/Paper';
import Draggable from 'react-draggable';
import { ResizableBox } from 'react-resizable';
import 'react-resizable/css/styles.css'; // Import the default styles
*/
// import store from '../../app/store';
/*
import { setLogPid, setLogStatus, setLogEntries, appendLogEntries } from '../../features/process/processSlice';
import { useSelector, useDispatch } from 'react-redux';
*/
import { netGet } from "../network";
import { Typography } from "@mui/material";
import './process.css';

var logEntries = [];
var infoValue = true;
var warnValue = true;
var errorValue = true;
var followValue = true;
var pidValue = null;

const setInfoValue = (v) => {
    infoValue = v;
};

const setWarnValue = (v) => {
    warnValue = v;
};

const setErrorValue = (v) => {
    errorValue = v;
};

const setFollowValue = (v) => {
    followValue = v;
}

const setPidValue = (v) => {
    pidValue = v;
}

/*
import { useEffect, useState, useRef } from 'react';
import { usePageVisibility } from './usePageVisibility';

export function MyComponent() {
  const isPageVisible = usePageVisibility();
  const timerIdRef = useRef(null);
  const [isPollingEnabled, setIsPollingEnabled] = useState(true);

  useEffect(() => {
    const pollingCallback = () => {
      // Your polling logic here
      console.log('Polling...');
      // Simulating an API failure in the polling callback
      const shouldFail = Math.random() < 0.2; // Simulate 20% chance of API failure

      if (shouldFail) {
        setIsPollingEnabled(false);
        console.log('Polling failed. Stopped polling.');
      }
    };

    const startPolling = () => {
      // pollingCallback(); // To immediately start fetching data
      // Polling every 30 seconds
      timerIdRef.current = setInterval(pollingCallback, 30000);
    };

    const stopPolling = () => {
      clearInterval(timerIdRef.current);
    };
    if (isPageVisible && isPollingEnabled) {
      startPolling();
    } else {
      stopPolling();
    }

    return () => {
      stopPolling();
    };
  }, [isPageVisible, isPollingEnabled]);

  return (
    // JSX for your component
  );
}
*/

/*
function DraggableResizablePaper(props) {
    const nodeRef = useRef(null);
  return (
    <Draggable nodeRef={nodeRef}
      handle="#draggable-dialog-title" // Use the dialog title as the drag handle
      cancel={'[class*="MuiDialogContent-root"]'} // Prevent dragging from content area
    >
      <ResizableBox ref={nodeRef}
        width={500} // Default width
        height={300} // Default height
        minConstraints={[200, 150]} // Minimum width and height
        maxConstraints={[800, 600]} // Maximum width and height
        {...props} // Pass the rest of the Paper props
      >
        <Paper {...props} />
      </ResizableBox>
    </Draggable>
  );
}

function ResizablePaper(props) {

  return (
      <ResizableBox 
        width={500} // Default width
        height={300} // Default height
        minConstraints={[200, 150]} // Minimum width and height
        maxConstraints={[800, 600]} // Maximum width and height
        {...props} // Pass the rest of the Paper props
      >
        <Paper {...props} />
      </ResizableBox>
  );
}
*/

function ProcessLogViewer(props) {
    const {
        wid, // workflow instance id
        open,
        title = 'Log Viewer',
        onClose,
        ...other
    } = props;

    const [pid, setPid] = useState(null);
    const [logData, setLogData] = useState([]);
    const [scrollIndex, setScrollIndex] = useState(-1);
    const [follow, setFollow] = useState(true);
    const [isPollingEnabled, setIsPollingEnabled] = useState(true);
    const [logCount, setLogCount] = useState(0);
    const [totalCount, setTotalCount] = useState(-1);
    const [loggerSize, setLoggerSize] = useState( {width: '1030px', height: '600px'})
    const bodyRef = useRef(null);
    const diagRef = useRef(null);
    const logViewerRef = useRef(null);
    const timerIdRef = useRef(null);
    const theme = useTheme();

    const LIMIT = 300;
    const INTERVAL = 4000;

    const RED = "\x1b[31m";
    const GRAY = "\x1b[38;5;8m";
    const DARKGRAY = "\x1b[38;5;233m";
    const BLUE = "\x1b[38;5;26m";
    const ORANGE = "\x1b[38;5;214m";
    const INFO =  "INFO ";
    const WARN =  "WARN ";
    const ERROR = "ERROR";

     useEffect( () => {
        if ( open && wid ) {
            logEntries = [];
            setLogData([]);
            setFollow(true);
            setFollowValue(true);
            // getLogStatus(true);
            netGet('/api/workflow/inst/' + encodeURIComponent(wid))
                .then(response => response.json())
                .then(winst => {
                    if ( winst?.properties?.jobId ) {
                        const jobid = winst.properties.jobId;
                        console.log('Job ID = ' + jobid);
                        setPidValue(jobid);
                        getLogStatus(true);
                        startPolling();
                    }
                }).catch(error => {
                    // ignore
                    console.log('Error polling workflow instance: ' + error);
                });
            
            
        } else {
            setPidValue(null);
            setLogData([]);
            setIsPollingEnabled(false);
            setLogCount(0);
            setTotalCount(-1);
            stopPolling();
        }
        /*
        if ( open && isPollingEnabled && follow) {
            // console.log('Starting polling logs...');
            startPolling();
        } else {
            // console.log('No polling logs needed!');
            stopPolling();
        }
        */
        return () => {
            stopPolling();
          };
        
    }, [open,wid]);

    const startPolling = () => {
        // pollingCallback(); // To immediately start fetching data
        // Polling every 3 seconds
        timerIdRef.current = setInterval(pollingCallback, INTERVAL);
    };

    const stopPolling = () => {
        if ( timerIdRef?.current ) {
            clearInterval(timerIdRef.current);
        }
    };

    const pollingCallback = () => {
        getLogStatus(false);
    };


    const getLogStatus = (clear, jobId=pidValue) => {
        if (jobId) {
            netGet('/api/process/logcount/' + jobId)
                .then(response => response.json())
                .then(countStatus => {
                    // console.log('LOG count status = ' + JSON.stringify(countStatus) + ", clear = " + clear);
                    if ( clear ) {
                        logEntries = [];
                    }
                    let offset = logEntries.length;
                    const needsPolling = !(countStatus.status === 'COMPLETED' || countStatus.status === 'FAILED') || offset < countStatus.count;
                    // dispatch(setLogStatus(countStatus.status));
                    setTotalCount(countStatus.count);
                    setIsPollingEnabled(needsPolling);
                    // console.log('NEEDS POLLING = ' + needsPolling + ' : follow = ' + followValue + " offset=" + offset);
                    if (needsPolling && followValue) {
                        pollLogs(offset, LIMIT, jobId);
                    }
                }).catch(error => {
                    // ignore
                });
        }
    };

    const pollLogs = (offset,limit, jobid=pidValue) => {
        if (jobid) {
            netGet(`/api/process/logs/${jobid}?offset=${offset}&limit=${limit}`)
                .then(response => response.json())
                .then(data => {
                    // console.log('LOGS: ' + pid + ': ' + JSON.stringify(data));
                    // console.log("\u001b[32mHa, I'm green, obviously.");

                    if (Array.isArray(data)) {
                        data.forEach( item => logEntries.push(item));
                        // console.log("Entries length = " + logEntries.length);
                        processLogs();
                    }
                })
                .catch(error => {
                    // ignore
                });
        }
    }

    const processLogs = () => {
        if (Array.isArray(logEntries)) {
            let logs = []; // offset <= 0 ? [] : [ ...logData];
            let count = 0;
            console.log('Log entries size = ' + logEntries.length);
            logEntries.forEach(r => {
                //const l = `${DARKGRAY}${r.level} ${r.logDate}${GRAY}${r.message}`;
                // logs.push(l);
                // entries.push(r);
                let date = dayjs(r.logDate).format('[[]YY-MM-DD HH:mm:ss]');
                let line;
                switch (r.level) {
                    case 'INFO':
                        if (infoValue) {
                            line = `${BLUE}${INFO} ${DARKGRAY}${date} ${GRAY}${r.message}`;
                            logs.push(line);
                            count += r.message.split(/\r\n|\r|\n/).length;
                        }
                        break;
                    case 'WARN':
                        if (warnValue) {
                            line = `${ORANGE}${WARN} ${DARKGRAY}${date} ${GRAY}${r.message}`;
                            logs.push(line);
                            count += r.message.split(/\r\n|\r|\n/).length;
                        }
                        break;
                    case 'ERROR':
                        if (errorValue) {
                            line = `${RED}${ERROR} ${DARKGRAY}${date} ${GRAY}${r.message}`;
                            logs.push(line);
                            count += r.message.split(/\r\n|\r|\n/).length;
                        }
                        break;
                }
            });
            setLogData(logs);
            setTimeout(() => {
                setScrollIndex(count - 1);
                // console.log('LOAD LOGS = ' + count);

            }, 200);
        }
    };

    const filterLogs = (infoFlag, warnFlag, errorFlag) => {
        if ( Array.isArray(logEntries) ) {
            let logs = [];
            let count = 0;
            logEntries.forEach( r => {
                let date = dayjs(r.logDate).format('[[]YY-MM-DD HH:mm:ss]');
                let line='';
                if ( r.level === 'INFO' && infoFlag ) {
                    line = `${BLUE}${INFO} ${DARKGRAY}${date} ${GRAY}${r.message}`;
                    logs.push(line);
                    count += r.message.split(/\r\n|\r|\n/).length;
                } 
                if ( r.level === 'WARN' && warnFlag) {
                    line = `${ORANGE}${WARN} ${DARKGRAY}${date} ${GRAY}${r.message}`;
                    logs.push(line);
                    count += r.message.split(/\r\n|\r|\n/).length;
                }
                if ( r.level === 'ERROR' && errorFlag) {
                    line = `${RED}${ERROR} ${DARKGRAY}${date} ${GRAY}${r.message}`;
                    logs.push(line);
                    count += r.message.split(/\r\n|\r|\n/).length;
                }
                
            });
            setLogData(logs);
            //setScrollIndex(count-1);
            setScrollIndex(1);
            //console.log('LOGS = ' + count);
        }
    };

    const infoChanged = (event) => {
        setInfoValue(event.target.checked);
        filterLogs(event.target.checked, warnValue, errorValue);
    }

    const warnChanged = (event) => {
        setWarnValue(event.target.checked);
        filterLogs(infoValue, event.target.checked, errorValue);
    }

    const errorChanged = (event) => {
        setErrorValue(event.target.checked);
        filterLogs(infoValue, warnValue, event.target.checked);
    }


    const onDialogClose = () => {
        if ( typeof onClose === 'function') {
            onClose();
        }
    }

    const onResizeEnd = (event) => {
        // console.log('Resize w = ' + event.target.name + ' ' + JSON.stringify(event?.target?.getBoundingClientRect()));
        if ( diagRef?.current ) {
            const r = diagRef.current.getElement().getBoundingClientRect();
            console.log(`Dialog Width: ${r.width}, Height: ${r.height}`);
            // console.log('Resize ' +  JSON.stringify(r));

            // setLoggerSize({width: r.width - 32, height: r.height - 160});
            setLoggerSize({width: `${r.width}`, height: `${r.height - 30}px`});
        }
    }

    const handleFollowChange = (event) => {
        const f = event.target.checked;
        setFollow(f);
        setFollowValue(f);
        console.log('Following = ' + f);
        if ( f ) {
            startPolling();
        } else {
            stopPolling();
        }
    };

    const footerContent = (
        <Box sx={{padding: 1, display: 'flex', justifyContent: 'space-between', paddingLeft: 1, paddingTop: 3}}>
            <FormGroup>
                <FormControlLabel 
                    control={<Switch checked={follow} onChange={handleFollowChange} />} 
                    label="Follow"
                    slotProps={{
                        typography: {
                            color: follow ? 'textPrimary' : 'textDisabled'
                        }
                    }}
                     />
            </FormGroup>
            <Button variant="outlined" onClick={onDialogClose} sx={{ minWidth: '7em', marginRight: 2 }}>Close</Button>
        </Box>
    );

    const headerContent = (
        <Box>
            <Typography sx={{fontWeight: 'bold', fontSize: '2em'}}>{title}</Typography>
            <Box sx={{ paddingBottom: '1ex', paddingTop: '1ex' }}>
                <FormControlLabel control={<Checkbox checked={infoValue}
                    onChange={infoChanged} />} label="INFO" />
                <FormControlLabel control={<Checkbox checked={warnValue}
                    onChange={warnChanged} />} label="WARN" />
                <FormControlLabel control={<Checkbox checked={errorValue}
                    onChange={errorChanged} />} label="ERROR" />
            </Box>
        </Box>
    );

    return (
        <PrimeDialog visible={open} modal 
            style={{ width: '1080px', height: '600px' }} 
            headerStyle={{display: 'none'}}
            contentStyle={{padding: '15px', overflow: 'hidden', paddingLeft: '20px'}}
            ref={diagRef}
            onHide={onDialogClose}
            onResizeEnd={onResizeEnd}
            showCloseIcon={false} dismissableMask={true}>

            <LogViewer
                ref={logViewerRef}
                height={loggerSize.height}
                header={headerContent}
                footer={footerContent}
                hasLineNumbers={false}
                data={logData}
                scrollToRow={scrollIndex}
                style={{ fontFamily: 'mono', fontSize: '10pt'}}
            />

        </PrimeDialog>
    );
}

function ProcessLogViewer3(props) {
    const {
        wid, // workflow instance id
        pid, // job process id
        open,
        title = 'Log Viewer',
        onClose,
        ...other
    } = props;
    const [logData, setLogData] = useState([]);
    // const [logEntries, setLogEntries] = useState([]);
    const [scrollIndex, setScrollIndex] = useState(-1);
    /*
    const [infoValue, setInfoValue] = useState(true);
    const [warnValue, setWarnValue] = useState(true);
    const [errorValue, setErrorValue] = useState(true);
    */
    const [isPollingEnabled, setIsPollingEnabled] = useState(true);
    const [logCount, setLogCount] = useState(0);
    const [totalCount, setTotalCount] = useState(-1);
    const timerIdRef = useRef(null);
    /*
    const logEntries = useSelector(state => state.processLogs.entries);
    const logPid = useSelector(state => state.processLogs.pid);
    const logStatus = useSelector(state => state.processLogs.status);

    const dispatch = useDispatch();
    */

    const LIMIT = 300;
    const INTERVAL = 4000;

    const RED = "\x1b[31m";
    const GRAY = "\x1b[38;5;8m";
    const DARKGRAY = "\x1b[38;5;233m";
    const BLUE = "\x1b[38;5;26m";
    const ORANGE = "\x1b[38;5;214m";
    const INFO =  "INFO ";
    const WARN =  "WARN ";
    const ERROR = "ERROR";

    useEffect( () => {
        if ( open ) {
            logEntries = [];
            setLogData([]);
            getLogStatus(true);
            
        }
        if ( open && isPollingEnabled ) {
            // console.log('Starting polling logs...');
            startPolling();
        } else {
            // console.log('No polling logs needed!');
            stopPolling();
        }
        return () => {
            stopPolling();
          };

    }, [open,pid]);
    /*
    useEffect( () => {
        
    },[pid]);
    */

    useEffect( () => {
        if ( open && isPollingEnabled ) {
            // console.log('Starting polling logs...');
            startPolling();
        } else {
            // console.log('No polling logs needed!');
            stopPolling();
        }
    },[isPollingEnabled]);

    

    const startPolling = () => {
        // pollingCallback(); // To immediately start fetching data
        // Polling every 3 seconds
        timerIdRef.current = setInterval(pollingCallback, INTERVAL);
    };

    const stopPolling = () => {
        if ( timerIdRef?.current ) {
            clearInterval(timerIdRef.current);
        }
    };

    const pollingCallback = () => {
        getLogStatus(false);
    };

    const getLogStatus = (clear) => {
        if (pid) {
            netGet('/api/process/logcount/' + pid)
                .then(response => response.json())
                .then(countStatus => {
                    console.log('LOG count status = ' + JSON.stringify(countStatus) + ", clear = " + clear);
                    if ( clear ) {
                        logEntries = [];
                    }
                    let offset = logEntries.length;
                    const needsPolling = !(countStatus.status === 'COMPLETED' || countStatus.status === 'FAILED') || offset < countStatus.count;
                    // dispatch(setLogStatus(countStatus.status));
                    setTotalCount(countStatus.count);
                    setIsPollingEnabled(needsPolling);
                    // console.log('NEEDS POLLING = ' + needsPolling + " offset=" + offset);
                    if (needsPolling) {
                        pollLogs(offset, LIMIT);
                    }
                }).catch(error => {
                    // ignore
                });
        }
    };

    const pollLogs = (offset,limit) => {
        if (pid) {
            netGet(`/api/process/logs/${pid}?offset=${offset}&limit=${limit}`)
                .then(response => response.json())
                .then(data => {
                    // console.log('LOGS: ' + pid + ': ' + JSON.stringify(data));
                    // console.log("\u001b[32mHa, I'm green, obviously.");

                    if (Array.isArray(data)) {
                        data.forEach( item => logEntries.push(item));
                        // console.log("Entries length = " + logEntries.length);
                        processLogs();
                    }
                })
                .catch(error => {
                    // ignore
                });
        }
    }

    const processLogs = () => {
        if (Array.isArray(logEntries)) {
            let logs = []; // offset <= 0 ? [] : [ ...logData];
            let count = 0;
            console.log('Log entries size = ' + logEntries.length);
            logEntries.forEach(r => {
                //const l = `${DARKGRAY}${r.level} ${r.logDate}${GRAY}${r.message}`;
                // logs.push(l);
                // entries.push(r);
                let date = dayjs(r.logDate).format('[[]YY-MM-DD HH:mm:ss]');
                let line;
                switch (r.level) {
                    case 'INFO':
                        if (infoValue) {
                            line = `${BLUE}${INFO} ${DARKGRAY}${date} ${GRAY}${r.message}`;
                            logs.push(line);
                            count += r.message.split(/\r\n|\r|\n/).length;
                        }
                        break;
                    case 'WARN':
                        if (warnValue) {
                            line = `${ORANGE}${WARN} ${DARKGRAY}${date} ${GRAY}${r.message}`;
                            logs.push(line);
                            count += r.message.split(/\r\n|\r|\n/).length;
                        }
                        break;
                    case 'ERROR':
                        if (errorValue) {
                            line = `${RED}${ERROR} ${DARKGRAY}${date} ${GRAY}${r.message}`;
                            logs.push(line);
                            count += r.message.split(/\r\n|\r|\n/).length;
                        }
                        break;
                }
            });
            setLogData(logs);
            setTimeout(() => {
                setScrollIndex(count - 1);
                // console.log('LOAD LOGS = ' + count);

            }, 200);
        }
    };

    const filterLogs = (infoFlag, warnFlag, errorFlag) => {
        if ( Array.isArray(logEntries) ) {
            let logs = [];
            let count = 0;
            logEntries.forEach( r => {
                let date = dayjs(r.logDate).format('[[]YY-MM-DD HH:mm:ss]');
                let line='';
                if ( r.level === 'INFO' && infoFlag ) {
                    line = `${BLUE}${INFO} ${DARKGRAY}${date} ${GRAY}${r.message}`;
                    logs.push(line);
                    count += r.message.split(/\r\n|\r|\n/).length;
                } 
                if ( r.level === 'WARN' && warnFlag) {
                    line = `${ORANGE}${WARN} ${DARKGRAY}${date} ${GRAY}${r.message}`;
                    logs.push(line);
                    count += r.message.split(/\r\n|\r|\n/).length;
                }
                if ( r.level === 'ERROR' && errorFlag) {
                    line = `${RED}${ERROR} ${DARKGRAY}${date} ${GRAY}${r.message}`;
                    logs.push(line);
                    count += r.message.split(/\r\n|\r|\n/).length;
                }
                
            });
            setLogData(logs);
            //setScrollIndex(count-1);
            setScrollIndex(1);
            //console.log('LOGS = ' + count);
        }
    };


    const onCancelClick = () => {
        if ( typeof onClose === 'function' ) {
            onClose();
        }
    };

    const infoChanged = (event) => {
        setInfoValue(event.target.checked);
        filterLogs(event.target.checked, warnValue, errorValue);
    }

    const warnChanged = (event) => {
        setWarnValue(event.target.checked);
        filterLogs(infoValue, event.target.checked, errorValue);
    }

    const errorChanged = (event) => {
        setErrorValue(event.target.checked);
        filterLogs(infoValue, warnValue, event.target.checked);
    }

    return (
        <Dialog
            maxWidth={'980px'}
            open={open}
            onClose={onClose}
            slotProps={{
                paper: {
                    sx: {
                        minWidth: 1080,
                        minHeight: 600,
                        maxHeight: 730,
                    }
                }
            }}
            
        >
            <DialogTitle sx={{ fontWeight: 'bold' }}>{title}</DialogTitle>
            <DialogContent>
                <Box sx={{paddingBottom: '1ex'}}>
                    <FormControlLabel control={<Checkbox checked={infoValue}
                                onChange={infoChanged} />} label="INFO" />
                    <FormControlLabel control={<Checkbox checked={warnValue}
                                onChange={warnChanged} />} label="WARN" />
                    <FormControlLabel control={<Checkbox checked={errorValue}
                                onChange={errorChanged} />} label="ERROR" />
                </Box>
                <LogViewer
                    hasLineNumbers={false}
                    height={300}
                    width={1050}
                    data={logData}
                    scrollToRow={scrollIndex}
                    style={{fontFamily: 'mono', fontSize: '10pt'}}
                />

            </DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={onCancelClick} sx={{ minWidth: '7em' }}>Close</Button>
            </DialogActions>
        </Dialog>
    );

}
/*
function LogViewer1(props) {
    const {
        pid,
        ...other
    } = props;
    const [itemCount, setItemCount] = useState(0);
    const [items, setItems] = useState([]);
    const [hasNextPage, setHasNextPage] = useState(true);

    const isItemLoaded = index => !hasNextPage || index < items.length;

    const loadMoreItems = (startIndex, stopIndex) => {
        for (let index = startIndex; index <= stopIndex; index++) {
          itemStatusMap[index] = LOADING;
        }
        return new Promise(resolve =>
          setTimeout(() => {
            for (let index = startIndex; index <= stopIndex; index++) {
              itemStatusMap[index] = LOADED;
            }
            resolve();
          }, 2500)
        );
      };

    // Render an item or a loading indicator.
    const Item = ({ index, style }) => {
        let content;
        if (!isItemLoaded(index)) {
            content = "Loading...";
        } else {
            content = items[index].level + ' ' + items[index].logDate + ' ' + items[index].message;
        }

        return <div style={style}>{content}</div>;
    };

}
*/

export { ProcessLogViewer };